import React from "react";
import { useNavigate } from "react-router-dom";
import "./AIProductCard.css";

const AIProductCard = ({ product }) => {

    const navigate = useNavigate();

    const handleProductClick = () => {

        /*
            Replace this with your actual
            product details route.
        */

        navigate(`/ShopDetails/${product.product_id}`);

    };

    return (

        <div
            className="ai_product_card"
            onClick={handleProductClick}
        >

            {/* Product Image */}

            <div className="ai_product_image_wrapper">

                <img
                    src={product.image_url}
                    alt={product.product_name_english}
                    className="ai_product_image"
                />

            </div>

            {/* Product Content */}

            <div className="ai_product_content">

                {/* Product Name */}

                <h4 className="ai_product_name">

                    {product.product_name_english}

                </h4>

                {/* Supplier */}

                <div className="ai_supplier_name">

                    <span className="sold_by">

                        Sold by

                    </span>

                    <span className="supplier_company">

                        {product.company_name_english}

                    </span>

                </div>

                {/* Price */}

                <div className="ai_price_section">

                    <span className="ai_currency">

                        {product.currency}

                    </span>

                    <span className="ai_price">

                        {product.price_per_unit}

                    </span>

                    <span className="ai_unit">

                        / {product.unit_of_measure}

                    </span>

                </div>

                {/* Information */}

                <div className="ai_product_meta">

                    <div className="meta_chip">

                        {product.country_of_origin}

                    </div>

                    <div className="meta_chip">

                        MOQ {product.minimum_order_quantity} {product.unit_of_measure}

                    </div>

                </div>


            </div>

        </div>

    );

};

export default AIProductCard;